import IconLink2 from '@/components/elements/icon/icon-link2';
import { CountryCode } from '@/i18n/countries';
import { externalLinks } from '@/utils/constants';

const whatsappBase = 'https://api.whatsapp.com/send?phone=%2B';
const viberBase = 'viber://chat/?number=%2B';
// const viberLinkDesktop = `viber://chat/?number=+xxx`;
// const viberLinkMobile = `viber://contact/?number=+xxx`;

interface ContactsProps {
    size: number;
    country?: CountryCode;
    className?: string;
}

export default function Contacts2(props: ContactsProps) {
    const viberLink = viberBase + (props.country === 'RU' ? externalLinks.phone_ru : externalLinks.phone);
    const whatsappLink = whatsappBase + (props.country === 'RU' ? externalLinks.phone_ru : externalLinks.phone);

    return (
        <>
            <IconLink2
                href={externalLinks.telegram}
                icon="fab-telegram"
                text="Telegram"
                sizeSm={props.size}
                sizeMd={props.size}
                className={props.className}
            />
            <IconLink2
                href={externalLinks.instagram}
                icon="fab-instagram"
                text="Instagram"
                sizeSm={props.size}
                sizeMd={props.size}
                className={props.className}
            />
            <IconLink2
                href={`mailto:${externalLinks.email}`}
                icon="far-envelope"
                text="Email"
                sizeSm={props.size}
                sizeMd={props.size}
                className={props.className}
            />
            <IconLink2
                href={viberLink}
                icon="fab-viber"
                text="Viber"
                sizeSm={props.size}
                sizeMd={props.size}
                className={props.className}
            />
            <IconLink2
                href={whatsappLink}
                icon="fab-whatsapp"
                text="WhatsApp"
                sizeSm={props.size}
                sizeMd={props.size}
                className={props.className}
            />
        </>
    );
}
